/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_char33 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred+33 char`)
};

const es_phred_char33 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carácter Phred+33`)
};

const de_phred_char33 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred+33-Zeichen`)
};

const nl_phred_char33 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred+33-teken`)
};

const fr_phred_char33 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractère Phred+33`)
};

const it_phred_char33 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carattere Phred+33`)
};

const pt_br2_phred_char33 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractere Phred+33`)
};

const pt_phred_char33 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carácter Phred+33`)
};

const ja_phred_char33 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred+33文字`)
};

const zh_phred_char33 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred+33 字符`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_char33 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_char33(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_char33", locale)
	if (locale === "en") return en_phred_char33(inputs)
	if (locale === "es") return es_phred_char33(inputs)
	if (locale === "de") return de_phred_char33(inputs)
	if (locale === "nl") return nl_phred_char33(inputs)
	if (locale === "fr") return fr_phred_char33(inputs)
	if (locale === "it") return it_phred_char33(inputs)
	if (locale === "pt-BR") return pt_br2_phred_char33(inputs)
	if (locale === "pt") return pt_phred_char33(inputs)
	if (locale === "ja") return ja_phred_char33(inputs)
	return zh_phred_char33(inputs)
};